import { AxiosResponse, HTTPClient } from '@abaco/web-common/src/HTTP';
import { Warehouse, StockItem } from '../models/Warehouse';
import { EmptyPagedResults, PagedResults, PagingParams } from '@abaco/web-common/src/Paging';

export default class WarehouseApi {

    private http: HTTPClient;
    private rootPath: string;

    constructor(http: HTTPClient, rootPath: string) {
        this.http = http;
        this.rootPath = rootPath;
    }

    public async canSelectWarehouse(pkCuaa: number): Promise<boolean>{
        const url = `${this.rootPath}/v1/user_registry/module_competencies/BEST_PRACTICE/SOGG_WAREHOUSE_EDIT`
        const params = {
            subject_id: pkCuaa
        }
        const res = await this.http.get(url, {params});

        return res.data.result;
    }

    public async getWarehouses(pk_cuaa: number, warehouse_type: string, paging: PagingParams): Promise<PagedResults<Warehouse>> {
        const res = await this.http.get(`${this.rootPath}/v1/warehouse/subjects/${pk_cuaa}/warehouses`, {
            params: {
                offset: paging.offset,
                count: paging.count,
                filter: `warehouse_type eq ${warehouse_type}`
            }
        })

        return res.data;
    }

    public async getWarehouse(pk_cuaa: number, warehouse_id: number): Promise<Warehouse> {
        const res = await this.http.get(`${this.rootPath}/v1/warehouse/subjects/${pk_cuaa}/warehouses/${warehouse_id}`);

        return res.data;
    }

    public async getWarehousePhytochemicals(pk_cuaa: number, warehouse_id: number, descriptionSearch: string | null, ingredientSearch: string | null, cropCode: string | null, adversityS: string | null, activeDate: Date | null, onlyOrganic: boolean): Promise<Warehouse> {
        let url = `${this.rootPath}/v1/warehouse/subjects/${pk_cuaa}/warehouses/${warehouse_id}/phytochemicals?1=1`;
        if(cropCode){
            url += `&crop_code=${cropCode}`;
        }
        if(adversityS){
            url += `&adversity_s_code=${adversityS}`;
        }
        const filter = [];
        if(descriptionSearch && descriptionSearch != ""){
            filter.push(`^item_name like ${descriptionSearch.toUpperCase()}`);
        }
        if(ingredientSearch && ingredientSearch != ""){
            filter.push(`^active_substance like ${ingredientSearch.toUpperCase()}`);
        }
        if(activeDate){
            filter.push(`revocation_for_filter ge ${activeDate.getTime()}`);
        }
        if(onlyOrganic){
            filter.push(`fg_bio eq 1`);
        }
        const res = await this.http.get(url);
        return res.data;
    }

    public async findWarehouse(pk_cuaa: number, warehouse_type: string, item_id: number): Promise<{warehouses: Warehouse[]; totalcount: number}> {
        let res = new EmptyPagedResults<Warehouse>();
        let count = 0;
        let records: Warehouse[] = [];
        do {
            res = await this.getWarehouses(pk_cuaa, warehouse_type, { offset: count, count: 300 });
            count += res.count;
            records = [...records, ...res.records]
        } while (count < res.totalcount);

        const stockedItemsPromise: Promise<AxiosResponse<PagedResults<StockItem>>>[] = records.map(async r => this.http.get(`${this.rootPath}/v1/warehouse/subjects/${pk_cuaa}/warehouses/${r.warehouse_id}/stocked_items`, {
            params: {
                filter: `item_id eq ${item_id}`,
                offset: 0,
                count: 1
            }
        }));

        const stockedItems = (await Promise.all(stockedItemsPromise))
                                .filter(st => st.data.totalcount > 0)
                                .map(st => st.data.records[0]);
        const warehouses = records.filter(r => stockedItems.some(st => st.warehouse_id === r.warehouse_id));

        return {warehouses, totalcount: res.totalcount};
    }

    //get lotto
    public async getLotFromItemId(pk_cuaa: number, warehouse_id: number, stockItemId: number): Promise<any> {
        const res = await this.http.get(`${this.rootPath}/v1/warehouse/subjects/${pk_cuaa}/warehouses/${warehouse_id}/stocks`, {
            params: {
                count: 100,
                filter: `stock_item_id eq ${stockItemId}`
            }
        })
        return res.data;
    }
}
